// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__TbdEp","Logo":"Toolbar_Logo__3N1Ne","DesktopOnly":"Toolbar_DesktopOnly__1TJR9"};